<template> 
    <div class="breadcrumbs">
        <div 
            v-for="item in links" :key="item.id"
            class="breadcrumbs__link" 
        >
            <router-link  
                :to="item.url"
                v-if="item.url != undefined"
            >
                <span>{{item.title}}</span> 

                <span class="breadcrumbs__link-line">&#47;</span>
            </router-link>

            <span 
                v-else
                class="breadcrumbs__span"
            >
                {{item.title}}
            </span>
        </div> 
    </div> 
</template>

<script>
export default {
    name: 'main-breadcrumbs',
    props: {
        links: Array
    }
}
</script>

<style lang="scss" scoped>
.breadcrumbs {
    display: flex;
    font-size: 14px;
    padding: 12px 0;
    border-top: 1px solid rgba(178, 180, 183, 0.25);

    &__link {
        margin-right: 5px;

        &-line {
            margin-left: 5px;
        }
    }

    &_bb { 
        border-bottom: 1px solid rgba(178, 180, 183, 0.25);
    }
}
</style>